import { useQuery } from '@tanstack/react-query';

import {
	findMostRelevantTicketOptions,
	type MyTicketView,
} from '@mopla/ticketshop-api';

import { IMyTicket } from '../types';

import { mapMyTicketDto } from './mapMyTicketDto';

interface IUseMostRelevantTicketResult {
	ticket: IMyTicket | null;
	isLoading: boolean;
	error: Error | null;
}

/**
 * The next relevant preordered or active ticket for the home card.
 * GET /api/v1/me/tickets/next — used by the MobileHomeIndexPage.
 * Returns `null` when BE has no relevant ticket (204), so the caller can hide
 * the home card.
 */
export const useMostRelevantTicket = (): IUseMostRelevantTicketResult => {
	const { data, isLoading, error } = useQuery({
		...findMostRelevantTicketOptions(),
		refetchOnMount: 'always',
		select: (res: MyTicketView): IMyTicket | null =>
			res?.purchaseId ? mapMyTicketDto(res) : null,
	});

	return { ticket: data ?? null, isLoading, error };
};
